import { SHOW_BOOKING_SUCCESS } from "./types";

const showBookingSuccess = () => ({
  type: SHOW_BOOKING_SUCCESS,
});

export default showBookingSuccess;
